import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ReturnToCheckoutBanner } from "@cinch-labs/return-to-checkout-banner";
import { ReturnToCheckoutModal } from "@cinch-labs/shared-ui-return-to-checkout-modal";
import { SharedUiHeaderV2 } from "@cinch-labs/shared-ui-header-v2";
import { SharedPromoBanner } from "@cinch-labs/shared-ui-promo-banner";
import { ZendeskChatButton } from "@cinch-labs/shared-zendesk-messenger";
import { useFavouritesStore, useFavouriteVehicles } from "@cinch-nx/data-favourites";
import { useOrdersStore } from "@cinch-nx/data-orders";
import { useUserStore } from "@cinch-nx/data-user";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { sendDigitalDataEvent, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { SharedUiFooter } from "@cinch-nx/shared-ui-footer";
import { Gradient } from "@cinch-nx/shared-ui";
import { datadogRum } from "@datadog/browser-rum";
import cx from "classnames";
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { getLastCheckoutStage, checkoutTimes, useViewport } from "@cinch-labs/shared-util";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Breadcrumbs from "../breadcrumbs/breadcrumbs";
import styles from "./layout.module.css";
import { Hero } from "../hero";
export function Layout(param) {
    var children = param.children, breadCrumbs = param.breadCrumbs, heroProps = param.heroProps, _showBorderRadius = param.showBorderRadius, showBorderRadius = _showBorderRadius === void 0 ? false : _showBorderRadius, _showFooterBorderRadius = param.showFooterBorderRadius, showFooterBorderRadius = _showFooterBorderRadius === void 0 ? true : _showFooterBorderRadius, useVerticalGradient = param.useVerticalGradient, hasBleed = param.hasBleed, _hasPromoBanner = param.hasPromoBanner, hasPromoBanner = _hasPromoBanner === void 0 ? true : _hasPromoBanner;
    var ref;
    var trackEvent = useAnalytics(function(state) {
        return state.trackEvent;
    });
    var trackedEvent = useRef(null);
    var ref1 = useState(false), shouldShowCheckoutModal = ref1[0], setShouldShowCheckoutModal = ref1[1];
    var ref2 = useState(false), shouldShowBasketIcon = ref2[0], setShouldShowBasketIcon = ref2[1];
    var ref3 = useState(false), isHomePage = ref3[0], setIsHomePage = ref3[1];
    var ref4 = useState(false), shouldShowZendeskButton = ref4[0], setShouldShowZendeskButton = ref4[1];
    var ref5 = useOrdersStore(), refreshActiveOrder = ref5.refreshActiveOrder, checkIfVehicleIsReserved = ref5.checkIfVehicleIsReserved, extendOrderExpiryDate = ref5.extendOrderExpiryDate, activeOrder = ref5.activeOrder, cancelOrder = ref5.cancelOrder;
    var ref6 = useUserStore(function(state) {
        var ref, ref1;
        return {
            isLoggedIn: state.status === "valid",
            firstName: (ref = state.profile) === null || ref === void 0 ? void 0 : ref.firstName,
            email: (ref1 = state.profile) === null || ref1 === void 0 ? void 0 : ref1.email,
            token: state.token
        };
    }), isLoggedIn = ref6.isLoggedIn, firstName = ref6.firstName, email = ref6.email, token = ref6.token;
    var ref7;
    var stageName = (ref7 = process.env["STAGE_NAME"]) !== null && ref7 !== void 0 ? ref7 : "local";
    var favouritesData = useFavouriteVehicles().favouritesData;
    var ref8;
    var favourites = useMemo(function() {
        return (ref8 = favouritesData === null || favouritesData === void 0 ? void 0 : favouritesData.favouriteVehicles) !== null && ref8 !== void 0 ? ref8 : [];
    }, [
        favouritesData
    ]);
    var fetchFavourites = useFavouritesStore().fetchFavourites;
    useEffect(function() {
        if (!isLoggedIn) return;
        fetchFavourites();
    }, [
        fetchFavourites,
        isLoggedIn
    ]);
    useEffect(function() {
        if (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.orderRef) {
            setShouldShowBasketIcon(true);
        }
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.orderRef
    ]);
    useEffect(function() {
        var ref, ref1;
        var internalAPIs = [
            "landing-www.snc-prod.aws.cinch.co.uk",
            "landing-articles.snc-prod.aws.cinch.co.uk",
            "landing-categories.snc-prod.aws.cinch.co.uk", 
        ];
        if (!((ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes("_storyblok")) && !((ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href.endsWith("sitemap.xml")) && internalAPIs.some(function(p) {
            var ref;
            return (ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes(p);
        }) && process.env["STAGE_NAME"] === "production") {
            var _pathname;
            window.location.href = "https://www.cinch.co.uk".concat((_pathname = window.location.pathname) !== null && _pathname !== void 0 ? _pathname : "");
        }
        if (window.location.pathname === "/") {
            setIsHomePage(true);
        }
    }, []);
    var vw = useViewport({
        updateOnOrientationChange: true,
        updateOnResize: true
    }).vw;
    useEffect(function() {
        if (window.location.pathname.startsWith("/used-cars/") && vw < 768) {
            setShouldShowZendeskButton(false);
        } else setShouldShowZendeskButton(true);
    }, [
        vw
    ]);
    var handleShouldShowBasketIcon = useCallback(function() {
        setShouldShowBasketIcon(!shouldShowBasketIcon);
    }, [
        shouldShowBasketIcon
    ]);
    var handleCheckoutVisibility = useCallback(function() {
        setShouldShowCheckoutModal(!shouldShowCheckoutModal);
    }, [
        shouldShowCheckoutModal
    ]);
    var handleTrackEvent = useCallback(function(data) {
        var trackedValue = "".concat(data.label, " ").concat(data.action);
        if (trackedValue !== trackedEvent.current) {
            trackEvent({
                type: TrackingEventTypes.ADOBE,
                eventName: data.name,
                data: {
                    event: data
                }
            });
            trackedEvent.current = trackedValue;
            return;
        }
        if (trackedEvent.current !== null) {
            trackedEvent.current = null;
        }
    }, [
        trackEvent
    ]);
    var handleCancelOrder = function() {
        var _ref = _async_to_generator(function(orderid, cancelOrderReason, token) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShouldShowBasketIcon(false);
                        return [
                            4,
                            cancelOrder(orderid, cancelOrderReason, token)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function handleCancelOrder(orderid, cancelOrderReason, token) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref9 = checkoutTimes(activeOrder), timeRemainingInSeconds = ref9.timeRemainingInSeconds, isExpiringSoon = ref9.isExpiringSoon;
    var gapMenuItemShown = readFromEnv(Env.GapInsuranceFlag) === "true";
    var updatedCinchCareCopy = readFromEnv(Env.ServicingAndWarrantyFlag) === "true";
    var IS_MOBILE_APP = "object" !== "undefined" && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    var _obj, _obj1;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !IS_MOBILE_APP && hasPromoBanner && /*#__PURE__*/ _jsx(SharedPromoBanner, {
                name: "sale",
                sendDigitalDataEvent: sendDigitalDataEvent
            }),
            !IS_MOBILE_APP && /*#__PURE__*/ _jsx("div", {
                className: cx(styles.headerContainer, (_obj = {}, _define_property(_obj, styles.verticalGradient, useVerticalGradient), _define_property(_obj, styles.borderRadiusHeader, showBorderRadius), _define_property(_obj, styles.headerHasBleed, hasBleed), _obj)),
                children: /*#__PURE__*/ _jsx(SharedUiHeaderV2, {
                    handleTrackEvent: handleTrackEvent,
                    setIsCheckoutModalVisible: handleCheckoutVisibility,
                    isCheckoutModalVisible: shouldShowCheckoutModal,
                    stageName: stageName,
                    isLoggedIn: isLoggedIn,
                    accessToken: (token === null || token === void 0 ? void 0 : token.access_token) || "",
                    firstName: firstName,
                    email: email,
                    favourites: favourites,
                    refreshActiveOrder: refreshActiveOrder,
                    activeOrder: activeOrder || undefined,
                    shouldShowBasketIcon: shouldShowBasketIcon,
                    isGapMenuItemShown: gapMenuItemShown,
                    isUpdatedCinchCareCopy: updatedCinchCareCopy,
                    checkoutModal: /*#__PURE__*/ _jsx(ReturnToCheckoutModal, {
                        activeOrder: activeOrder || undefined,
                        lastVisitedCheckoutStage: getLastCheckoutStage(activeOrder),
                        onClose: function() {
                            return setShouldShowCheckoutModal(!shouldShowCheckoutModal);
                        },
                        handleShouldShowBasketIcon: handleShouldShowBasketIcon,
                        timeRemainingInSeconds: timeRemainingInSeconds,
                        withinExpiryTimeWindow: !!isExpiringSoon,
                        adminFeeFlag: readFromEnv(Env.AdminFeeReturnToCheckout) === "true",
                        adminFeeValueInPence: Number(readFromEnv(Env.AdminFeeValue)),
                        cancelOrder: cancelOrder,
                        isLoggedIn: isLoggedIn,
                        accessToken: (token === null || token === void 0 ? void 0 : token.access_token) || "",
                        refreshActiveOrder: refreshActiveOrder,
                        checkIfVehicleIsReserved: checkIfVehicleIsReserved,
                        extendOrderExpiryDate: extendOrderExpiryDate,
                        trackEvent: trackEvent
                    }),
                    children: !IS_MOBILE_APP ? /*#__PURE__*/ _jsx(Hero, {
                        heroProps: heroProps
                    }) : null
                })
            }),
            /*#__PURE__*/ _jsxs("main", {
                id: "main-content",
                className: cx((_obj1 = {}, _define_property(_obj1, styles.borderRadiusMain, showBorderRadius), _define_property(_obj1, styles.borderRadiusHome, isHomePage), _obj1)),
                children: [
                    breadCrumbs && /*#__PURE__*/ _jsx(Breadcrumbs, {
                        breadcrumbs: breadCrumbs
                    }),
                    /*#__PURE__*/ _jsx(Gradient, {}),
                    children
                ]
            }),
            shouldShowZendeskButton && /*#__PURE__*/ _jsx(ZendeskChatButton, {}),
            /*#__PURE__*/ _jsx(ReturnToCheckoutBanner, {
                activeOrder: activeOrder,
                extendOrderExpiry: extendOrderExpiryDate,
                refreshActiveOrder: refreshActiveOrder,
                sendDigitalDataEvent: sendDigitalDataEvent,
                reportDatadogError: function(error, ctx) {
                    return datadogRum.addError(error, ctx);
                },
                accessToken: token === null || token === void 0 ? void 0 : token.access_token,
                adminFeeFlag: readFromEnv(Env.AdminFeeReturnToCheckout) === "true",
                adminFeeValueInPence: Number(readFromEnv(Env.AdminFeeValue)),
                cancelOrder: handleCancelOrder
            }),
            /*#__PURE__*/ _jsx(SharedUiFooter, {
                showFooterBorderRadius: showFooterBorderRadius
            })
        ]
    });
}
export default Layout;
